// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import { Container } from 'reactstrap';
import AppointmentFlowWizard from 'components/templates/AppointmentFlowWizard/';
import Success from './components/Success';
import WhiteConfirmation from './components/WhiteConfirmation';
import Modal from 'components/atoms/Modal';
import Reminder from './components/Reminder';

import './ConfirmationPage.scss';

// Constants
import { TRANSPORTATION } from 'constants/transportation';
import { WAITING_OPTIONS } from 'constants/selfCheckIn';

const { CALL, TEXT, IN_WAITING_AREA } = WAITING_OPTIONS;
const { DROPOFF, WAITER } = TRANSPORTATION;
const SELF_CHECKIN_OPTIONS = [CALL, TEXT, IN_WAITING_AREA];

const ns = 'self-checkin-confirmation-page';

export type Props = {
  intl: IntlShape,
  transportationOption: string,
  selfCheckinWaitState: string
};

class ConfirmationPage extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    (this: any).confirmationModal = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    (this: any).confirmationModal.current.setShowModal(true);
  }

  confirmationModal: React.Ref<any>;

  closeConfirmationModal = () => {
    (this: any).confirmationModal.current.setShowModal(false);
  };

  needServiceAdvisor = () => {
    const { transportationOption, selfCheckinWaitState } = this.props;
    const needAdvisorAssistance =
      transportationOption !== DROPOFF && transportationOption !== WAITER;
    return (
      needAdvisorAssistance ||
      SELF_CHECKIN_OPTIONS.indexOf(selfCheckinWaitState) !== -1
    );
  };

  getPage = () => {
    return (
      <React.Fragment>
        <Success
          date={new Date()}
          needServiceAdvisor={this.needServiceAdvisor()}
        />
        <WhiteConfirmation />
        <Modal
          showCloseButton={false}
          ref={this.confirmationModal}
          className={`${ns} modal`}
          size={'large'}
          autoScrollTop={true}
        >
          {<Reminder closeConfirmationModal={this.closeConfirmationModal} />}
        </Modal>
      </React.Fragment>
    );
  };

  render() {
    return (
      <AppointmentFlowWizard
        className={ns}
        isSelfCheckIn={true}
        header={() => {}}
        footer={() => {}}
        body={() => (
          <Container className={`${ns}__container`}>{this.getPage()}</Container>
        )}
      />
    );
  }
}

export default ConfirmationPage;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/ConfirmationPage.js